import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgDrugsDealen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      d="M19 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2M22.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M20.5 12a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
    />
    <path
      fill="#F8BADD"
      d="M13 20.82a5 5 0 1 0 0-10 5 5 0 0 0 0 10"
    />
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="m17.729 17.515-9.7-2.42.242-.97 9.7 2.42z"
      clipRule="evenodd"
    />
    <path
      fill="#F8BADD"
      d="M24 22a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
    />
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="m27.688 16.369-6.86 4.12-.515-.858 6.86-4.12z"
      clipRule="evenodd"
    />
    <path
      fill="#F170B8"
      d="M5.28 34h16.63a2.77 2.77 0 0 0 1.5-.45L34.82 26a2.63 2.63 0 0 0 .9-3.37A2.66 2.66 0 0 0 32 21.57l-9.25 5.49a2.33 2.33 0 0 0-2.34-2.32H9.83a4.85 4.85 0 0 0-2.18.51l-3.27 1.62a.68.68 0 0 0-.38.61v5.24A1.28 1.28 0 0 0 5.28 34"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M6.403 23.975a6.7 6.7 0 0 1 3.068-.735h10.643a2.94 2.94 0 0 1 2.916 2.971v-.005l-.5.004-.5-.006a1.94 1.94 0 0 0-1.922-1.964h.002v-.5l-.004.5h.002H9.47a5.7 5.7 0 0 0-2.613.625l-2.63 1.34-.454-.89zm13.705 4.195H12.82v1h7.294a2.94 2.94 0 0 0 2.916-2.959v.005l-.5-.006-.5.004a1.94 1.94 0 0 1-1.922 1.956m0 0h.002v.5l-.004-.5z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgDrugsDealen);

export default ForwardRef;
